import React, { useCallback } from 'react';
import { useSelector } from "react-redux";
import { useApi } from "helpers/useApi";
export const useAppointmentRequestSrv = () => {
    const { api } = useApi();
    const portalSessionMeta = useSelector((state: any) => state.portal.micrositeSession);
    console.log("portalSessionMeta", portalSessionMeta)

    const getAppointmentDetails = useCallback(() => {
        console.log("portalSessionMeta ww", portalSessionMeta)
        return api.get('/api/appointments/getdetails');
    }, [api, portalSessionMeta]);

    const submitAppointmentRequest = useCallback((data: any) => {
        return api.post('/api/appointments/submitappointment', data)
    }, [api]);

    return { getAppointmentDetails, submitAppointmentRequest }
}